import React from 'react';
import urls, { relativeUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const ActivityLauncherMenu = () => (
  <RibbonMenu
    icon="comments"
    name="activity"
    message="fair.launcher.activities"
    url={`#${relativeUrl(urls.ACTIVITIES)}`}
    className="aridhia-activity-launcher-menu"
  />
);

export default ActivityLauncherMenu;
